import React, {Fragment} from "react";
import Sidebar from "../../components/Sidebar";
import NsAccordion from "../../components/accordion/NsAccordion";
import {Tab, Tabs} from "react-bootstrap";
import ContenutoArchivioDocumentiController from "./components/documenti/ContenutoArchivioDocumentiController";
import ContenutoModelliArchivioController from "./components/modelli/ContenutoModelliArchivioController";
import ModalConfirm from "../../components/ModalConfirm";
import ModalAddModelloArchivio from "./components/modelli/ModalAddModelloArchivio";
import ModalFiltroArchivio from "./components/ModalFiltroArchivio";
import NsBreadcrumbs from "../../components/NsBreadcrumbs";
import ModalAddMarcaArchivio from "./components/marche/ModalAddMarcaArchivio";

export default function ArchivioModelliView({
                                                idMarca,
                                                marca,
                                                temi,
                                                titoli,
                                                titoloSel,
                                                getAlberoStruttura,
                                                isMobile,
                                                keyTab,
                                                setKeyTab,
                                                keyTabSottotemi,
                                                setKeyTabSottotemi,
                                                handlerRefreshTabs,
                                                handlerRefreshTitoli,
                                                selectTitolo,
                                                titoloToDelete,
                                                eliminaTitolo,
                                                eliminaMarca,
                                                showConfirmDelTitolo,
                                                showConfirmDelMarca,
                                                setShowConfirmDelTitolo,
                                                setShowConfirmDelMarca,
                                                idTitoloUpdate,
                                                showModalUpdateTitolo,
                                                showModalUpdateMarca,
                                                closeModalUpdateTitolo,
                                                updateTitoloOk,
                                                handlerModificaTitolo,
                                                handlerEliminaTitolo,
                                                handlerModificaMarca,
                                                handlerEliminaMarca,
                                                isAdmin,
                                                showModalFiltri,
                                                setShowModalFiltri,
                                                numFiltroArchivio,
                                                getTitoloSottotema,
                                                handleClickBreadcrumbs,
                                                closeModalUpdateMarca,
                                                updateMarcaOk,
                                            }) {

    return (
        <Fragment>
            <ModalFiltroArchivio
                show={showModalFiltri}
                handleClose={() => setShowModalFiltri(false)}
                submitOk={() => {
                    setShowModalFiltri(false);
                }}
            />
            <ModalConfirm
                show={showConfirmDelTitolo}
                handleClose={() => setShowConfirmDelTitolo(false)}
                handleOk={() => {
                    eliminaTitolo();
                    setShowConfirmDelTitolo(false);
                }}
                testo={"Sicuro di voler eliminare il titolo: " + (titoloToDelete && titoloToDelete.modello) + "?"}
            />
            <ModalConfirm
                show={showConfirmDelMarca}
                handleClose={() => setShowConfirmDelMarca(false)}
                handleOk={() => {
                    eliminaMarca();
                    setShowConfirmDelMarca(false);
                }}
                testo={"Sicuro di voler eliminare la marca: " + (marca && marca.marca) + "?"}
            />
            <ModalAddModelloArchivio
                idMarca={idMarca}
                marca={marca}
                idTitolo={idTitoloUpdate}
                show={showModalUpdateTitolo}
                handleClose={closeModalUpdateTitolo}
                submitOk={updateTitoloOk}
            />
            <ModalAddMarcaArchivio
                idMarca={idMarca}
                tipoVeicolo={marca?.tipo_veicolo}
                show={showModalUpdateMarca}
                handleClose={closeModalUpdateMarca}
                submitOk={updateMarcaOk}
            />
            <div className={"container-fluid pt-3"}>
                <Fragment>
                    <Sidebar
                        sidebarContent={() => {
                            return isMobile ?
                                <NsAccordion
                                    titolo={'Struttura kpi'}
                                    label={'fas fa-stream'}>
                                    {
                                        getAlberoStruttura()
                                    }
                                </NsAccordion>
                                : getAlberoStruttura()
                        }}
                    >
                        <div className={'row'}>
                            <div className={'col-md-2'}>
                            </div>
                            <div className={'col-md-8'}>
                                {
                                    titoloSel ?
                                        <h4 className={"text-center"}>{`${titoloSel.marca} ${titoloSel.modello}`}</h4>
                                        :
                                        <h4 className={"text-center"}>{marca && marca.marca}</h4>
                                }
                            </div>
                            <div className={'col-md-2 text-end'}>
                                {
                                    isAdmin && titoloSel &&
                                    <Fragment>
                                        <button
                                            type={'button'}
                                            className={'btn btn-dark btn-sm'}
                                            data-toggle="tooltip" title="Modifica Modello"
                                            onClick={handlerModificaTitolo}
                                        >
                                            <i className="fas fa-edit"/>
                                        </button>
                                        <button
                                            type={'button'}
                                            className={'btn btn-dark btn-sm'}
                                            data-toggle="tooltip" title="Elimina Modello"
                                            onClick={handlerEliminaTitolo}
                                        >
                                            <i className="fas fa-trash"/>
                                        </button>
                                    </Fragment>
                                }
                                {
                                    isAdmin && !titoloSel &&
                                    <Fragment>
                                        <button
                                            type={'button'}
                                            className={'btn btn-dark btn-sm'}
                                            data-toggle="tooltip" title="Modifica Marca"
                                            onClick={handlerModificaMarca}
                                        >
                                            <i className="fas fa-edit"/>
                                        </button>
                                        <button
                                            type={'button'}
                                            className={'btn btn-dark btn-sm'}
                                            data-toggle="tooltip" title="Elimina Marca"
                                            onClick={handlerEliminaMarca}
                                        >
                                            <i className="fas fa-trash"/>
                                        </button>
                                    </Fragment>
                                }
                                <button
                                    type={'button'}
                                    className={'btn btn-principal btn-sm'}
                                    data-toggle="tooltip" title="Filtri"
                                    onClick={() => setShowModalFiltri(true)}
                                >
                                    <i className="fas fa-filter"/> {numFiltroArchivio > 0 ? numFiltroArchivio : ''}
                                </button>
                            </div>
                        </div>
                        <hr className={"dropdown-divider"}/>
                        <NsBreadcrumbs
                            handleClick={handleClickBreadcrumbs}
                        />
                        {
                            titoloSel ?
                                <Fragment>
                                    <Tabs
                                        id="temi"
                                        activeKey={keyTab}
                                        onSelect={(k) => {
                                            setKeyTab(k);

                                            const arrTemiFiltrati = temi.filter(t => t.codice === k);
                                            if (arrTemiFiltrati.length > 0 && arrTemiFiltrati[0].sottotemi && arrTemiFiltrati[0].sottotemi !== '') {
                                                setKeyTabSottotemi(arrTemiFiltrati[0].sottotemi.split(';')[0]);
                                            }
                                        }}
                                        className="mb-3"
                                    >
                                        {
                                            temi.map(tema =>
                                                <Tab
                                                    key={tema.codice}
                                                    eventKey={tema.codice}
                                                    title={`${tema.tema} (${tema.num_documenti})`}
                                                    mountOnEnter={true}
                                                    unmountOnExit={true}
                                                >
                                                    {
                                                        tema.sottotemi && tema.sottotemi !== '' ?
                                                            <Tabs
                                                                id="sottotemi"
                                                                activeKey={keyTabSottotemi}
                                                                onSelect={(k) => setKeyTabSottotemi(k)}
                                                                className="mb-3"
                                                            >
                                                                {
                                                                    tema.sottotemi.split(';').map(sottotema =>
                                                                        <Tab
                                                                            key={sottotema}
                                                                            eventKey={sottotema}
                                                                            title={getTitoloSottotema(tema, sottotema)}
                                                                            mountOnEnter={true}
                                                                            unmountOnExit={true}
                                                                        >
                                                                            <ContenutoArchivioDocumentiController
                                                                                titolo={titoloSel}
                                                                                tema={tema}
                                                                                sottotema={sottotema}
                                                                                handlerRefreshTabs={handlerRefreshTabs}
                                                                            />
                                                                        </Tab>)
                                                                }
                                                            </Tabs>
                                                            :
                                                            <ContenutoArchivioDocumentiController
                                                                titolo={titoloSel}
                                                                tema={tema}
                                                                handlerRefreshTabs={handlerRefreshTabs}
                                                            />
                                                    }
                                                </Tab>)
                                        }
                                    </Tabs>
                                </Fragment>
                                :
                                <ContenutoModelliArchivioController
                                    idMarca={idMarca}
                                    marca={marca}
                                    titoli={titoli}
                                    handlerRefreshTitoli={handlerRefreshTitoli}
                                    selectTitolo={selectTitolo}
                                />
                        }
                    </Sidebar>
                </Fragment>
            </div>
        </Fragment>
    );
}